<template>
	<div>
		<div class="modal-header align-items-center">
			<h3 class="modal-title">
				{{ $t("pos.x-atchot") }} ( {{ $t("pos.x-nachalo") }} :
				{{ currentReport.startDate }} - {{ $t("pos.x-kones") }} :
				{{ currentReport.endDate }})
			</h3>
			<div class="d-flex align-items-center">
				<!-- PRINT CURRENT_REPORT -->
				<b-link v-if="!isZReport" @click.prevent="printReport" style="color: #000000; font-size: 1.1rem"
					class="mr-2">
					<i class="fa fa-print editBtn"></i>
				</b-link>
				<button type="button" @click="close" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">×</span>
				</button>
			</div>
		</div>
		<b-container class="d-flex justify-content-between mb-1 hidden-print" style="max-width: 100%;">
			<h5 class="modal-title d-flex align-items-center" v-for="(rate, index) in lastCurrencyRates"
				:class="index === 0 ? 'ml-1' : index === lastCurrencyRates.length - 1 ? 'mr-1' : ''"
				:key="`cbu_currency_rates-pos-top-${index}`">
				<span v-if="rate.currencyCode === 'USD'" class="flag-icon flag-icon-us"></span>
				<span v-else-if="rate.currencyCode === 'EUR'" class="d-inline-flex">
					<img :src="`${publicPath}img/eunion.png`" alt="europian union flag" style="width: 1.5rem;">
				</span>
				<span v-else-if="rate.currencyCode === 'RUB'" class="flag-icon flag-icon-ru"></span>
				<span v-else-if="rate.currencyCode === 'GBP'" class="flag-icon flag-icon-gb"></span>
				<span v-else-if="rate.currencyCode === 'UZS'" class="flag-icon flag-icon-uz"></span>
				<!--							CURRENCY NAME								-->
				<span class="ml-1">{{ rate.currencyName }} (<b style="color: orange;">{{
					rate.ratioToDepCurrencyRate.toFixed(2) }}</b>)= <b>{{ rate.rate }}</b> <span
						:style="rate.difference >= 0 ? { 'color': 'green' } : { 'color': 'red' }"
						style="font-size: .95rem;">
						{{ rate.difference }}
						<!--                        <i :class="`fa fa-arrow-circle-o-${rate.difference >= 0 ? 'up' : 'down'} ml-1`"></i>-->
					</span>
				</span>

			</h5>
		</b-container>
		<div class="modal-body">
			<b-row>
				<b-col align="left" class="pl-4">
					<b style="font-size: 0.9rem">Отдел:</b> {{ currentReport.departmentName }}
				</b-col>
				<b-col align="center">
					<b style="font-size: 0.9rem">Касса:</b> {{ currentReport.cashboxName }}
				</b-col>
				<b-col align="right" class="pr-4">
					<b style="font-size: 0.9rem">{{ $t("xAtchot.cashier") }}:</b> {{ currentReport.cashierFullName }}
				</b-col>
			</b-row>
			<div class="row">
				<div class="col-sm-12">
					<div class="modal-body box-z-report">
						<template v-if="currentReport.totalWithoutDiscount != 0">
							<table class="table table-striped table-bordered">
								<tbody>
									<tr v-for="(value, key) in currentReport.payments" :key="key">
										<td v-if="key === 'QARZGA' && value > 0">
											{{ $t("xAtchot.debt") }}
										</td>
										<td v-if="key === 'HOMIYLIK' && value > 0">Спонсорство</td>
										<td v-if="key === 'CERTIFICATE' && value > 0">{{ $t("sidebar.sales.sponsor")
											}}</td>
										<!--									<td v-if="key === 'CASH'">
																			{{ $t('xAtchot.title') }}
																		</td>-->
										<!--									<td v-if="key === 'BANK_CARD'">{{ $t('xAtchot.cart') }}</td>-->
										<td v-if="key === 'BANK_TRANSFER' && value > 0">Перечисления</td>

										<td v-if="key !== 'PAID' && value > 0">
											<span class="display_currency" data-currency_symbol="true">
												{{ value | currency({
													symbol: userDepCurrencyName, fractionCount: 2,
													symbolPosition: "back", thousandsSeparator: " ",})}}
											</span>
										</td>
									</tr>
									<!--				BANK_CARD PAYMENT TITLE				-->
									<tr>
										<th>{{ $t("xAtchot.cart") }}</th>
										<th></th>
										<!--                                        <th>{{currentReport.cardEuro}}</th>-->
									</tr>
									<!--				BANK_CARD PAYMENTS' ROW				-->
									<tr v-for="(payment, paymentTypeCode) in bankCardAmounts">
										<td>
											<span v-if="paymentTypeCode === 'UZCARD'">
												<img :src="`${publicPath}img/pos-images/uzcard.png`" alt="UzCard"
													style="width: 2.5rem" />&nbsp;
												<b>UZCARD</b>
											</span>
											<span v-else-if="paymentTypeCode === 'HUMO_UZS'">
												<img :src="`${publicPath}img/pos-images/humo_card.png`" alt="HumoCard"
													style="width: 2.5rem" />&nbsp;
												<b>HUMO</b>
											</span>
											<span v-else-if="paymentTypeCode === 'ONE_QR'">
												<img :src="`${publicPath}img/pos-images/one_qr.png`" alt="one_qr"
													style="width: 2.5rem" />&nbsp;
												<b>ONE_QR</b>
											</span>
											<span v-else-if="paymentTypeCode === 'VISA'">
												<img :src="`${publicPath}img/pos-images/visa_card.png`" alt="VisaCard"
													style="width: 2.5rem" />&nbsp;
												<b>VISA</b>
											</span>
											<span v-else-if="paymentTypeCode === 'CLICK_UZS'">
												<img :src="`${publicPath}img/pos-images/click.png`" alt="click png"
													style="margin-left:2px;width: 1.8rem" />&nbsp;
												<b>CLICK</b>
											</span>
											<span v-else-if="paymentTypeCode === 'UZUM_UZS'">
												<img :src="`${publicPath}img/pos-images/uzum.png`" alt="uzum png"
													style="width: 2rem" />&nbsp;
												<b>UZUM</b>
											</span>
											<span v-else-if="paymentTypeCode === 'PAYME_UZS'">
												<img :src="`${publicPath}img/pos-images/payme.png`" alt="Payme png"
													style="width: 2rem" />&nbsp;
												<b>PAYME</b>
											</span>
											<!--                                            <span>-->
											<!--                                                {{ paymentTypeCode }}-->
											<!--                                            </span>-->
										</td>
										<td>
											<span class="display_currency" data-currency_symbol="true">
												{{ payment[Object.keys(payment)[0]] | currency({
													symbol:
														Object.keys(payment)[0], fractionCount: 2, symbolPosition: "back",
												thousandsSeparator: " ",}) }}
											</span>
											<br v-if="Object.keys(payment).length > 1" />
											<span v-if="Object.keys(payment).length > 1" class="display_currency"
												data-currency_symbol="true">
												{{ payment[Object.keys(payment)[1]] | currency({
													symbol:
														Object.keys(payment)[1], fractionCount: 2, symbolPosition: "back",
												thousandsSeparator: " ",})}}
											</span>
										</td>
									</tr>
									<!--				CASH PAYMENT TITLE				-->
									<tr>
										<th>{{ $t("xAtchot.title") }}</th>
										<th></th>
										<!--                                        <th>{{currentReport.salesEuro}}</th>-->
									</tr>
									<!--				CASH PAYMENTS' ROW				-->
									<tr v-for="(cashAmount, currencyCode) in cashAmounts">
										<td>
											<span v-if="currencyCode === 'USD'" class="flag-icon flag-icon-us"
												style="font-size: 1.4rem"></span>
											<span v-else-if="currencyCode === 'EUR'">
												<img :src="`${publicPath}img/eunion.png`" alt="europian union flag"
													style="width: 1.95rem" />
											</span>
											<span v-else-if="currencyCode === 'RUB'" class="flag-icon flag-icon-ru"
												style="font-size: 1.4rem"></span>
											<span v-else-if="currencyCode === 'GBP'" class="flag-icon flag-icon-gb"
												style="font-size: 1.4rem"></span>
											<span v-else-if="currencyCode === 'UZS'" class="flag-icon flag-icon-uz"
												style="font-size: 1.4rem"></span>
											<span>{{ currencyCode }}</span>
										</td>
										<td>
											<!-- <span
                                                class="display_currency"
                                                data-currency_symbol="true"
                                            >
                                                {{
                                                    cashAmount
                                                        | currency({
                                                            symbol: currencyCode,
                                                            fractionCount: 2,
                                                            symbolPosition:
                                                                "back",
                                                            thousandsSeparator:
                                                                " ",
                                                        })
                                                }}
                                            </span> -->
											<span
												v-if="(depCurrencyCode != currencyCode) || Object.keys(cashAmount).length == 1"
												class="display_currency" data-currency_symbol="true">
												{{ cashAmount[Object.keys(cashAmount)[0]] | currency({
													symbol:
														Object.keys(cashAmount)[0], fractionCount: 2, symbolPosition: "back",
												thousandsSeparator: " ",})}}
											</span>
											<br>
											<span
												v-if="Object.keys(cashAmount).length > 1 && (depCurrencyCode != currencyCode)"
												class="display_currency" data-currency_symbol="true">
												{{ cashAmount[Object.keys(cashAmount)[1]] | currency({
													symbol:
														Object.keys(cashAmount)[1], fractionCount: 2, symbolPosition: "back",
												thousandsSeparator: " ",})}}
											</span>
										</td>
									</tr>
									<tr>
										<th class="text-right">Всего</th>
										<th>{{ currentReport.salesEuro }} USD</th>
									</tr>


									<!--                                    <tr class="success">-->
									<!--                                        <th>{{ $t("xAtchot.summa") }}</th>-->
									<!--                                        <td>-->
									<!--                                            <b>-->
									<!--                                                <span class="display_currency" data-currency_symbol="true">-->
									<!--                                                    {{ currentReport.totalWithoutDiscount | currency({ symbol: userDepCurrencyName,-->
									<!--													fractionCount: 2, symbolPosition: "back", thousandsSeparator: " ",}) }}-->
									<!--                                                </span>-->
									<!--                                            </b>-->
									<!--                                        </td>-->
									<!--                                    </tr>-->
									<!--                                    <tr class="success">-->
									<!--                                        <th>{{ $t("xAtchot.sumReturn") }}</th>-->
									<!--                                        <td>-->
									<!--                                            <b>-->
									<!--                                                <span class="display_currency" data-currency_symbol="true">-->
									<!--                                                    {{ currentReport.totalRefundAmount | currency({ symbol: userDepCurrencyName,-->
									<!--													fractionCount: 2, symbolPosition: "back", thousandsSeparator: " ",}) }}-->
									<!--                                                </span>-->
									<!--                                            </b>-->
									<!--                                        </td>-->
									<!--                                    </tr>-->
									<!--                                    <tr class="success">-->
									<!--                                        <th>{{ $t("xAtchot.summCashier") }}</th>-->
									<!--                                        <td>-->
									<!--                                            <b>-->
									<!--                                                <span class="display_currency" data-currency_symbol="true">-->
									<!--                                                    {{ (currentReport.totalWithDiscount - currentReport.totalRefundAmount)-->
									<!--													| currency({symbol: userDepCurrencyName, fractionCount: 2, symbolPosition:-->
									<!--														"back", thousandsSeparator: " ",}) }}-->
									<!--                                                </span>-->
									<!--                                            </b>-->
									<!--                                        </td>-->
									<!--                                    </tr>-->
									<!--                                    <tr class="success">-->
									<!--                                        <th>{{ $t("xAtchot.sumItem") }}</th>-->
									<!--                                        <td>-->
									<!--                                            <b>-->
									<!--                                                <span class="display_currency" data-currency_symbol="true">-->
									<!--													{{ currentReport.count }}-->
									<!--												</span>-->
									<!--                                            </b>-->
									<!--                                        </td>-->
									<!--                                    </tr>-->
									<!--                                    <tr class="success">-->
									<!--                                        <th>{{ $t("xAtchot.sumReturnItem") }}</th>-->
									<!--                                        <td>-->
									<!--											<b>-->
									<!--                                                <span class="display_currency" data-currency_symbol="true">-->
									<!--													{{ currentReport.refundCount }}-->
									<!--												</span>-->
									<!--                                            </b>-->
									<!--                                        </td>-->
									<!--                                    </tr>-->

									<tr>
										<th class="text-center" colspan="2">Продажи</th>
									</tr>
									<tr class="success">
										<th>Количество чеков продаж</th>
										<td><b>{{ currentReport.saleQty }}</b></td>
									</tr>
									<tr class="success">
										<th>Наличные</th>
										<td><b>{{ currentReport.saleCash.toFixed(2) | currency({
											symbol: 'UZS',
											fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '})
												}}</b></td>
									</tr>
									<tr class="success">
										<th>Банковские карты</th>
										<td><b>{{ currentReport.saleCard.toFixed(2) | currency({
											symbol: 'UZS',
											fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '})
												}}</b></td>
									</tr>

									<tr>
										<th class="text-center" colspan="2">Возвраты</th>
									</tr>
									<tr class="success">
										<th>Количество чеков возврата</th>
										<td><b>{{ currentReport.saleReturnQty }}</b></td>
									</tr>
									<tr class="success">
										<th>Наличные</th>
										<td><b>{{ currentReport.saleReturnCash.toFixed(2) | currency({
											symbol: 'UZS',
											fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '})
												}}</b></td>
									</tr>
									<tr class="success">
										<th>Банковские карты</th>
										<td><b>{{ currentReport.saleReturnCard.toFixed(2) | currency({
											symbol: 'UZS',
											fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '})
												}}</b></td>
									</tr>

									<tr>
										<th class="text-center" colspan="2">Итого</th>
									</tr>
									<tr class="success">
										<th>Выручка</th>
										<td><b>{{ currentReport.proceeds.toFixed(2) | currency({
											symbol: 'UZS',
											fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '})
												}}</b></td>
									</tr>
									<tr class="success">
										<th>Наличные</th>
										<td><b>{{ currentReport.proceedsCash.toFixed(2) | currency({
											symbol: 'UZS',
											fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '})
												}}</b></td>
									</tr>
									<tr class="success">
										<th>Банковские карты</th>
										<td><b>{{ currentReport.proceedsCard.toFixed(2) | currency({
											symbol: 'UZS',
											fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '})
												}}</b></td>
									</tr>
								</tbody>
							</table>
						</template>
						<template v-else>
							<b-alert variant="info" show>Продажи еще не сделаны</b-alert>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { TokenService } from "@/services/storage.service";
import FBoxService from "@/services/fbox.service";
import CurrencyService from "@/services/currency.service";
export default {
	name: "XAndZReport",
	props: {
		zReportId: {
			type: Number,
			default: null,
		},
		depId: {
			type: Number,
			default: null,
		},
		isZReport: {
			type: Boolean,
			default: false,
		},
		isFromZReportsPage: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			lastCurrencyRates: [],
		}
	},
	async created() {
		if (this.isZReport && !this.isFromZReportsPage) {
			if (this.zReportId) {
				await this.getZReportById({
					zReportId: this.zReportId,
					depId: this.depId,
				});
			} else await this.getCurrentZReport(localStorage.getItem('dep_id'));

		} else if (!this.isFromZReportsPage) await this.getCurrentXReport(localStorage.getItem('dep_id'));
		// CurrencyService.fetchLastCurrencyRate()
		// 	.then(res => {
		// 		this.lastCurrencyRates = res.data
		// 	})
		// 	.catch(er => {
		// 		console.log(er)
		// 	})
		CurrencyService.fetchLastCurrencyRate1(this.zReportId)
			.then(res => {
				this.lastCurrencyRates = res.data
			})
			.catch(er => {
				console.log(er)
			})
	},
	computed: {
		...mapState(["userDepCurrencyName"]),
		...mapState("zetReport", ["currentReport"]),
		...mapState("pos", {
			cashier: "cashierFullName",
		}),
		depCurrencyCode() {
			return TokenService.getDepCurrencyCode()
		},
		publicPath() {
			return process.env.BASE_URL;
		},
		cashAmounts() {
			return this.currentReport && this.currentReport.payments
				? this.currentReport.payments["CASH"]
					? this.currentReport.payments["CASH"]
					: {}
				: {};
		},
		bankCardAmounts() {
			return this.currentReport && this.currentReport.payments
				? this.currentReport.payments["BANK_CARD"]
					? this.currentReport.payments["BANK_CARD"]
					: {}
				: {};
		},
	},

	methods: {
		...mapActions("zetReport", [
			"getCurrentXReport",
			"getCurrentZReport",
			"getZReportById",
		]),
		close() {
			this.$emit("close");
		},
		async printReport() {
			await this.getCurrentXReport(localStorage.getItem('dep_id'));
			let resFromFBox = null;
			let errMsgFromFBox = null;
			try {
				resFromFBox = await FBoxService.xAndZReportCloseOrPrint({
					ipAddress: localStorage.getItem('ip_address'),
					data: this.currentReport.payments,
					closeZReport: false,
					salesEur: this.currentReport.salesEuro,
					totalEur: this.currentReport.totalWithDiscount - this.currentReport.totalRefundAmount,
					sellerName: this.currentReport.cashierFullName,
					cashboxName: this.currentReport.cashboxName,
					depName: this.currentReport.departmentName
				});
			} catch (e) {
				if (e.request && e.request.response) {
					let response = JSON.parse(e.request.response);
					errMsgFromFBox = response.message;
				}
			}

			if (!resFromFBox || !resFromFBox.data.is_success) {
				let fbError = resFromFBox ? resFromFBox.data.error.message : (errMsgFromFBox ? errMsgFromFBox : 'XATOLIK: Iltimos, qayta urunib ko\'ring')
				this.$vs.notify({
					title: fbError,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
	},
};
</script>

<style lang="scss">
.box-z-report {
	border-top-left-radius: 0;
	border-top-right-radius: 0;
	border-bottom-right-radius: 3px;
	border-bottom-left-radius: 3px;
	padding: 10px;

	table {

		td,
		th {
			font-size: 0.9rem;
			padding: 0.4rem;
		}
	}
}
</style>
